import { useTranslation } from 'react-i18next'
import HeroImage from '../../../assets/images/patnership-hero.svg'

const Hero = () => {
	const { t } = useTranslation('partnership')

	return (
		<h2 className='container mx-auto py-10 xl:py-20 text-center font-test-sohne-medium text-3xl xl:text-[64px] xl:leading-[104px]'>
			{t('hero.text1')} <img src={HeroImage} alt='parterns' className='inline-block w-24 h-auto xl:w-[164px] xl:h-[55px]' /> {t('hero.text2')}
		</h2>
	)
}

export default Hero
